import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { SilageType } from '~/api/services/co2'
import { FormFields } from '~/components/FormFields'

const NO_FUTTERBAU_ID = 3

interface Props {
  silageTypes: SilageType[]
}

const SilageTypes: React.FC<Props> = ({ silageTypes }) => {
  const { control, setValue, clearErrors } = useFormContext()
  const watchGrowSilage = useWatch({ control, name: 'silageTypes' }) || []

  return (
    <Form.Field>
      <label style={{ marginBottom: '1em' }}>{'Welche Futterbauverfahren betreiben Sie auf dem Betrieb?'}</label>
      <Form.Group>
        {[...silageTypes, { label: 'Kein Futterbau', id: NO_FUTTERBAU_ID }].map((option, index) => {
          return <FormFields.Checkbox
            name={'silageTypes'}
            key={option.id}
            id={option.id}
            checkboxValue={option.id}
            disabled={watchGrowSilage.find(silageId => silageId === NO_FUTTERBAU_ID) && index !== 2}
            checked={(watchGrowSilage || []).find(silageId => silageId === option.id)}
            onChange={(_, data) => {
              if (data.checked) {
                clearErrors('silageTypes')
                if (index === 2) {
                  setValue('silageTypes', [option.id])
                  setValue('grassSilage', null)
                  setValue('maizeSilage', null)
                  return
                }
                setValue('silageTypes', [...watchGrowSilage, option.id])
                return
              }
              setValue('silageTypes', watchGrowSilage?.filter(silage => silage !== option.id))
            }}
            label={option.label}
            control={control}
          />
        })}
      </Form.Group>
    </Form.Field>
  )
}
export default SilageTypes